import { Box, Tooltip } from "@mui/material";
import { Dispatch, FC, SetStateAction, useState } from "react";
import { NumberTextField } from "src/shared/components";
import { useAuth } from "src/shared/lib/rback/AuthContext";
import { ECurrency } from "src/shared/types/currency.types";

interface IEditableSpendsCellProps {
  id: number;
  spendsAdjustment: string;
  spends: string;
  serviceCurrency: ECurrency;
  handleAllAdjustmentsChange: (id: number, value: string) => void;
  refetch: () => void;
  setAllAdjustedSpends: Dispatch<
    SetStateAction<{ id: number; spends: string }[]>
  >;
}

export const EditableSpendsCell: FC<IEditableSpendsCellProps> = ({
  id,
  serviceCurrency,
  spends,
  spendsAdjustment,
  handleAllAdjustmentsChange,
}) => {
  const [inputValue, setInputValue] = useState<string>(spendsAdjustment);
  const { hasPermission } = useAuth();

  return (
    <Tooltip title={`${spends} ${serviceCurrency}`}>
      <Box sx={{ display: "flex", alignItems: "center" }} gap={2}>
        <NumberTextField
          slotProps={{
            input: {
              endAdornment: serviceCurrency,
            },
          }}
          name="spends"
          size="small"
          allowNegative={false}
          decimalScale={2}
          defaultValue={spendsAdjustment}
          onChange={(v) => {
            const value = String(v);
            setInputValue(value);
            handleAllAdjustmentsChange(id, value);
          }}
          value={inputValue}
          disabled={!hasPermission("partners.draft-report.edit")}
        />
      </Box>
    </Tooltip>
  );
};
